<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader style="border-bottom: 0">
						Gestion des raisons de litige
						<div class="card-header-actions">
							<CButton color="primary" v-on:click="showAddModal"> Ajouter une raison </CButton>
						</div>
					</CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							:remote-url="`/api/complaint_reasons`"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #actions="{ item }">
								<td class="text-center">
									<a
										class="text-center icon-space"
										href="#"
										@click.prevent="showEditModal(item)">
										<CIcon name="cil-pencil"></CIcon>
									</a>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>

		<AddModal ref="addModal" v-on:refresh="refresh()" />
		<EditModal ref="editModal" v-on:refresh="refresh()" />
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	import AddModal from './AddComplaintReason';
	import EditModal from './EditComplaintReason';

	export default {
		components: {
			GDataTableRemote,
			AddModal,
			EditModal,
		},

		data() {
			return {
				fields: [
					{ key: 'id', label: 'Identifiant' },
					{ key: 'text', label: 'Raison' },
					{ key: 'actions', filter: false },
				],
				activePage: 1,
			};
		},

		methods: {
			showAddModal: function () {
				this.$refs.addModal.showModal = true;
			},
			showEditModal: function (complaint) {
				this.$refs.editModal.complaint = complaint;
				this.$refs.editModal.showModal = true;
			},
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
		},
	};
</script>
